// List of known personal email domains
export const personalEmailDomains = [
  "gmail.com",
  "yahoo.com",
  "outlook.com",
  "hotmail.com",
  "aol.com",
  "googlemail.com",
  "yahoo.co.uk",
  "yahoo.in",
  "yahoo.ca",
  "yahoo.com.au",
  "yahoo.co.jp",
  "yahoo.es",
  "yahoo.it",
  "yahoo.de",
  "outlook.co.uk",
  "outlook.in",
  "hotmail.co.uk",
  "hotmail.fr",
  "live.com",
  "live.co.uk",
  "live.ca",
  "live.fr",
  "msn.com",
  "icloud.com",
  "me.com",
  "protonmail.com",
  "mail.com",
  "zoho.com",
  "zohomail.com",
  "gmx.com",
  "gmx.de",
  "yandex.com",
  "yandex.ru",
  "yandex.ua",
  "inbox.com",
  "lycos.com",
  "rediffmail.com",
  "tutanota.com",
  "fastmail.com",
  "hushmail.com",
  "mail.ru",
  "naver.com",
  "daum.net",
  "excite.com",
  "rambler.ru",
  "orange.fr",
  "sbcglobal.net",
  "verizon.net",
  "comcast.net",
  "att.net",
  "rocketmail.com",
  "qq.com",
  "btinternet.com",
  "virginmedia.com",
  "bt.com",
  "sky.com",
  "ntlworld.com",
  "tiscali.co.uk",
  "talktalk.net",
  "wanadoo.fr",
  "free.fr",
  "mailinator.com",
  "10minutemail.com",
  "guerrillamail.com",
  "throwawaymail.com",
  "temp-mail.org",
  "getnada.com",
  "yopmail.com",
  "fakeinbox.com",
  "maildrop.cc",
  "sharklasers.com",
  "example.com",
  "example.org",
  "test.com",
  "test.org",
];

// Regular expression to check if email ends with a personal domain
export const personalEmailRegex = new RegExp(
  `@(${personalEmailDomains.join("|")})$`,
  "i",
);

export const linkedInUrlRegex =
  /^https:\/\/(www\.)?linkedin\.com\/(in\/[A-z0-9_-]+(\/[A-z0-9_-]+)?|company\/[A-z0-9_-]+(\/[A-z0-9_-]+)?)\/?$/;
